import * as React from 'react';
import { ResponsiveValue } from 'styled-system';
import * as CSS from 'csstype';
import styled from 'styled-components';

import { themeGet, media, Flex, Box } from '@packages/ui';
import { LinkItemForFooterProps } from './LinkItemForFooter';
import { FooterLinkList } from './FooterLinkList';

export const NavigationListUl = styled(Flex)`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export const NavigationListLi = styled(Box)`
  padding: 0;
  margin: 0;
  display: flex;
  margin-bottom: ${themeGet.space(3)};
  > a {
    font-size: ${themeGet.fontSize(6)};
    font-weight: ${themeGet.fontWeight('lighter')};
    ${media.to.md`
      font-size: ${themeGet.fontSize(6)};
    `}
  }
`;

export const NavigationListHeadline = styled.h2``;

const Container = styled(Box)``;

export interface NavigationListPropsForFooter {
  headline?: string;
  items?: LinkItemForFooterProps[];
  flexDirection?: ResponsiveValue<CSS.Property.FlexDirection>;
}

export const NavigationListForFooter: React.FC<NavigationListPropsForFooter> = ({
  items = [],
  headline,
  flexDirection,
}) => (
  <Container as="nav">
    {headline ? <NavigationListHeadline>{headline}</NavigationListHeadline> : null}
    <NavigationListUl as="ul" flexDirection={flexDirection} justifyContent="center">
      {items.map((item) => (
        <NavigationListLi as="li" key={`navigation-list-item-${item.id}`}>
          <FooterLinkList {...item} />
        </NavigationListLi>
      ))}
    </NavigationListUl>
  </Container>
);
